/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DispatchAgentResult } from '../../models/dispatch-agent-result';

export interface ApiAgentsIdDispatchGet$Params {
  id: string;
  language_locale_id?: string;
  enable_first_message?: boolean;
  url_parameters?: {
[key: string]: string;
};

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
}

export function apiAgentsIdDispatchGet(http: HttpClient, rootUrl: string, params: ApiAgentsIdDispatchGet$Params, context?: HttpContext): Observable<StrictHttpResponse<DispatchAgentResult>> {
  const rb = new RequestBuilder(rootUrl, apiAgentsIdDispatchGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('language_locale_id', params.language_locale_id, {});
    rb.query('enable_first_message', params.enable_first_message, {});
    rb.query('url_parameters', params.url_parameters, {"style":"deepObject"});
    rb.header('x-space-id', params['x-space-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DispatchAgentResult>;
    })
  );
}

apiAgentsIdDispatchGet.PATH = '/api/Agents/{id}/dispatch';
